import { Col, Link, Row } from 'Common';
import { MainPage } from 'Container';
import { linkHandler } from 'utils/linkHandler';
import { ENABLE_MAINTENANCE_MODE } from 'config';
import Maintenance from 'Application/Maintenance/Maintenance';

const NotFoundPage = () => {
  if (ENABLE_MAINTENANCE_MODE) {
    return <Maintenance />;
  }

  return (
    <MainPage bodyClassName="background-green-c500" className="thank-you" title="404 - Seite nicht gefunden">
      <div className="container hero">
        <Row>
          <Col>
            <h2>Diese Seite konnten wir leider nicht finden.</h2>
            <br />
            <Link button to={linkHandler.get('home')} variant="inverted">
              Zur Startseite
            </Link>
          </Col>
        </Row>
      </div>
    </MainPage>
  );
};

export default NotFoundPage;
